import Vue from 'vue';
import CreateDynamicFormRequestModel from '../../generated/types/model/resource/CreateDynamicFormRequestModel';

export default class CreateDynamicFormRequestViewModel extends CreateDynamicFormRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
